<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left"> Смс коды</h4>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th width="15%">Код</th>
                                    <th width="25%">Телефон</th>
                                    <th width="25%">Тип</th>
                                    <th width="15%">Истекший</th>
                                    <th width="20%" class="d-none d-md-table-cell">Создано</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td>{{result.code}}</td>
                                    <td>{{result.phone}}</td>
                                    <td>
                                        <span v-if="result.type === 'REGISTER'">Регистрация</span>
                                    </td>
                                    <td>{{result.expired ? 'да' : 'нет'}}</td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.createdDate">{{result.createdDate}}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import {BPagination} from 'bootstrap-vue';

    import FilterModel from './../../shared/filter';

    export default {
        name: "SmsCodeList",
        components: {
            'b-pagination': BPagination
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('sms-code', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>